import React, {Component} from 'react';
import { Link } from "react-router";
import { database, auth } from '../firebase';
import Nav from '../components/Nav';
import NotFoundPage from './NotFoundPage';
import Yorumlar from '../components/Yorumlar';
import Like from '../components/Like';
import Alert from '../components/Alert';
import ms from '../ms';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import Skeleton from "react-loading-skeleton";
//import { Helmet } from 'react-helmet';

class BlogPost extends Component {
  constructor(props) {
    super(props)
    const savedMode = localStorage.getItem('darkMode') === 'true'; // Check if dark mode is saved in localStorage
    this.state = {
      post: [],
      tags: [],
      open: false,
      darkMode: savedMode
    };
  
    this.yazıSil = this.yazıSil.bind(this);
    this.yap = this.yap.bind(this);
    this.toggleDarkMode = this.toggleDarkMode.bind(this); // Method to toggle dark mode
  }

  componentDidMount() {
    auth.onAuthStateChanged(user => {
      if (user !== null) {
        database.ref("posts/"+window.location.pathname.slice(2)+"/postTags").get().then(snap => {
          if (!snap.exists()) {
            this.setState({ tags: ["Etiket Yok"] });
          }
        })
  
        const tagss = this.state.tags;
        database.ref("posts/"+window.location.pathname.slice(2)+"/postTags").on('child_added', snap => {
          tagss.push(snap.val())
          this.setState({tags: tagss});
        })
    
        database.ref("users/"+user.uid).get().then(snap => {
          if (snap.val().moderator == true) this.setState({ showTools: true });
        })
      }
    })
  
    database.ref("posts/"+window.location.pathname.slice(2)).get().then(snap => {
      this.setState({post: snap.val()})
        
      database.ref("users").get().then(snap2 => {
        var user = [];
        var post = snap.val();
        
        snap2.forEach(u => {
          if (u.val().uid === post.postAuthor) {
            user.push(u.val())
            this.setState({
              userImage: user[0].userImage || "/default_user.jpg",
              userName: user[0].userName,
              postContent: post.postContent
            });
          }
        })
      })
    })
  }

yazıSil() {
  if (auth.currentUser !== null) {
    database.ref("users/"+auth.currentUser.uid).get().then(async snap => {
      if (snap.val().moderator == true) {
        await database.ref("posts/"+window.location.pathname.slice(2)).remove();
        await database.ref("likes/"+window.location.pathname.slice(2)).remove();
        await database.ref("yorumlar/"+window.location.pathname.slice(2)).remove();
      } else this.yap();
    })
  }
}

yap() {
  if (this.state.open == false) this.setState({open: true});
  else this.setState({open: false});
}

toggleDarkMode() {
  this.setState((prevState) => {
    const newMode = !prevState.darkMode;
    localStorage.setItem('darkMode', newMode);
    return { darkMode: newMode };
  });
}

render() {

database.ref("posts/"+window.location.pathname.slice(2)).get().then(snap => {
  //if (!snap.exists()) return window.location.pathname = "/404";
})

  return (
    <div style={{background: "#f57029"}}>
      <Nav/>
      <div className='main'>
        <div className="card" style={{background: this.state.darkMode ? "#2f2d33" : "#F57029"}}>
          <button
            onClick={this.toggleDarkMode}
            className='darkMode'
            style={{backgroundColor: this.state.darkMode ? '#ffffff' : '#000000', color: this.state.darkMode ? '#000' : '#fff'}}
          >
            {this.state.darkMode ? "🌙" : "🌞"}
          </button>

          <div className='card-image-c'>
            {this.state.post.postTitle ? <img src={this.state.post.postImage || "/default.jpg"} alt="Yazının Görseli" className='card-image'/> : 
            <Skeleton width={"100%"} height={200}/>}
          </div>
          <div className="prfl" style={{display: "flex", marginBottom: "10px", padding: "10px 10px"}}>
            <Link to={"/profil/"+this.state.post.postAuthor}><img src={this.state.userImage} className="userImage"/></Link>
            <Link to={"/profil/"+this.state.post.postAuthor}><div className="userName">
              {this.state.userName ? this.state.userName + " -" : <Skeleton width={100} />}
            </div></Link>
            <a style={{marginTop: "8px", marginLeft: "5px"}}>
              {this.state.post.postDate ? ms(Date.now() - (this.state.post.postDate), {long: true}) + ` önce` : <Skeleton width={50} />}
            </a>
          </div>
          <h1 className="card-title">{this.state.post.postTitle || <Skeleton className="titleSkeleton"/>}</h1>
          <div className="textarea">
            {this.state.postContent ? <ReactMarkdown rehypePlugins={[rehypeRaw]}>{this.state.post.postContent}</ReactMarkdown> : <Skeleton className="textareaSkeleton" />}
            <Skeleton className="textareaSkeleton2" />
          </div>
          <Like/>
          <div className="card-date"></div>
          <div className="input-tag">
            <ul className="input-tag__tags" id="tags">
              <a style={{lineHeight: "27.33px", marginRight: "10px"}}>{this.state.tags.length > 0 ? "Etiketler:" : 
                (this.state.post.postTitle ? "Etiketler:" : <Skeleton width={150} style={{borderRadius: "20px", marginRight: "2px"}}/>)}</a>
              <div className="input-tag-list">
                {this.state.tags.map((tag, index) => (
                  <li key={index}>{tag}</li>
                ))}
              </div>
            </ul>
          </div>
          <div className="araçlar" style={{ display: this.state.showTools ? "block" : "none" }}>
            <button onClick={this.yazıSil}>Yazıyı Sil</button>
          </div>
          <Yorumlar/>
          <Alert
            baslik="Hey hey hey!" 
            content="Bunu yapamazsın >:D" 
            onay="Yapacağım!" 
            red="Peki..." 
            opened={this.state.open}
          />
        </div>
      </div>
    
    <style>{`
        html {
          background: #F57029;
        }
        
        .main {
          max-width: 762px;
          width: 100%;
          margin: 0 auto;
          margin-top: 49px;
          padding: 0;
        }

        .card {
          color: #fff;
          border-radius: 3px;
          padding: 25px;
          background: #F57029;
          width: 95%;
          text-align: center;
        }

        .darkMode {
          position: fixed;
          top: 20px;
          right: 20px;
          border-radius: 50%;
          cursor: pointer;
          z-index: 9999;
          width: 48px;
          height: 48px;
          font-size: 24px;
        }

        .textarea {
          text-align: left;
          max-width: 500px;
          margin: 0 auto;
          line-height: 22px;
        }

        .textareaSkeleton {
          width: 500px;
          border-radius: 20px;
          margin-bottom: 5px;
        }

        .textareaSkeleton2 {
          width: 470px;
          border-radius: 20px;
          margin-bottom: 5px;
        }

        .card-image {
          position: relative;
          margin: auto;
          border-radius: 10px;
          width: 100%;
          height: auto;
          object-fit: cover;
        }

        .userName {
          padding: 8px 0px 0 8px;
        }

        .userImage {
          width: 32px;
          height: 32px;
          background: #fff;
          border-radius: 100%;
          object-fit: cover;
          margin: 0;
        }

        .card-title {
          margin-top: 30px;
          margin-bottom: 50px;
          text-align: center;
          font-size: 48px;
        }

        .titleSkeleton {
          width: 550px;
          border-radius: 100px;
          margin-bottom: 5px;
        }

        .card-date {
          margin-top: 50px;
          text-align: right;
          color: #fff;
        }

        .input-tag {
          border-radius: 2px;
          display: flex;
          flex-wrap: wrap;
          padding: 5px 5px 0;
          max-width: 500px;
          margin: 10px auto;
          margin-top: -35px;
          cursor: default;
        }
        
        .input-tag__tags {
          display: inline-flex;
          flex-wrap: wrap;
          margin: 0;
          padding: 0;
          width: 100%;
        }

        .input-tag-list {
          display: contents;
          flex-wrap: wrap;
          margin: 0;
          padding: 0;
        }
        
        .input-tag__tags li {
          align-items: center;
          background: #2f2d33;
          border-radius: 12px;
          color: white;
          display: flex;
          font-weight: 300;
          list-style: none;
          margin-bottom: 5px;
          margin-right: 5px;
          padding: 5px 10px;
        }
        
        .input-tag__tags li button {
          align-items: center;
          appearance: none;
          background: #333333;
          border: none;
          border-radius: 50%;
          color: white;
          display: inline-flex;
          font-size: 12px;
          height: 15px;
          justify-content: center;
          line-height: 0;
          margin-left: 8px;
          padding: 0;
          transform: rotate(45deg);
          width: 15px;
        }
        
        .input-tag__tags li.input-tag__tags__input {
          background: none;
          flex-grow: 1;
          padding: 0;
        }

        .araçlar {
          position: absolute;
          display: none;
        }

        .araçlar button {
          width: 100px;
          height: 30px;
          border: 2px solid #fff;
          border-radius: 0 0 15px 5px;
          background: none;
          color: #fff;
          outline: none;
          transition: .2s;
        }

        .araçlar button:hover {
          background: #2f2d33;
        }

        @media (max-width: 900px) and (min-width: 623px) {
          .main {
            width: 100%;
            margin:0;
            text-align:center;
          }

          .card {
            width: 100%;
            max-width: 80%;
            margin: auto;
          }
        }

        @media (max-width: 623px) {
          .main {
            width: 100%;
            margin-top: 0;
          }

          .card {
            min-height: 100vh;
            margin: 0 auto;
            padding: 0;
            padding-bottom: 52px;
            width: 100%;
            box-shadow: none;
          }

          .card-image {
            height: 200px;
            border-radius: 0;
          }

          .titleSkeleton {
            width: 85%;
          }

          .card img .prfl img {
            position: relative;
            margin: auto;
            border-radius: 0;
            width: 100%;
            height: 300px;
            object-fit: cover;
          }

          .card-text {
            padding: 0 15px;
          }

          .prfl {
            padding: 10px 15px;
          }

          .textarea {
            padding: 0 15px;
          }

          .textareaSkeleton {
            width: 100%;
          }
          
          .textareaSkeleton2 {
            width: 100%;
          }

          .input-tag__tags {
            margin: revert;
            padding: 13px 10px;
          }

          .araçlar button {
            border-radius: 0 0 15px 0;
          }
        }
    `}</style>
  </div>
)}};

export default BlogPost;